// Read by extension configs to switch production vs non-production endpoints.
// webpack inlines process.env.NODE_ENV at build time, so this resolves to a
// single static string in the bundled output — no runtime check, no sed hack.
module.exports = process.env.NODE_ENV === 'production' ? 'production' : 'development';
